import {
  TyrianApp
} from './web/.js/target/scala-3.3.1/tinydb-web-opt.js';

TyrianApp.launch("myapp");